import { useState, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { soundManager } from '../utils/soundManager';

const SoundToggle = () => {
  const [muted, setMuted] = useState(soundManager.isMuted());

  const toggleSound = () => {
    const newMutedState = soundManager.toggleMute();
    setMuted(newMutedState);
  };

  return (
    <button
      onClick={toggleSound}
      className="fixed bottom-8 left-8 z-50 p-3 rounded-full transition-all duration-300 border"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderColor: '#C6A85A',
        color: '#C6A85A',
        backdropFilter: 'blur(10px)'
      }}
      title={muted ? 'Unmute sounds' : 'Mute sounds'}
      data-testid="sound-toggle"
    >
      {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
    </button>
  );
};

export default SoundToggle;
